import React from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';
import { IGridCell } from '../../../../../../ui/types/IGridCell';

const StaticPropertyCell: React.FC<IGridCell> = ({ dataItem, field }) => {
    const intl = useInternationalization();

    let item = field && dataItem[field];
    let value: any;
    let className = '';
    let objectItem: any;

    if (dataItem[field] === undefined) {
        value = '';
    }

    if (typeof item === 'object' && item !== null) {
        objectItem = item;
    } else {
        const index = field?.lastIndexOf('_');
        let objectField = field && field.substring(0, index);
        objectItem = dataItem[objectField];
    }

    value = objectItem === undefined || objectItem.rowAmount === null ? '' : objectItem.rowAmount;

    if (value && objectItem?.dataType === 'date') {
        value = intl.toString(new Date(value), 'd');
        className = 'align-right';
    }

    if (value && (objectItem?.dataType === 'number' || objectItem?.dataType === 'percent')) {
        let format = objectItem?.dataType === 'percent' ? 'p' : 'n';

        let val = parseFloat(value);
        value = Number.isFinite(val) ? val : null;

        value = intl.toString(value, `${format}${objectItem.scale}`);
        className = 'align-right';
    }

    let linkValue = value && objectItem?.type === 'website' && (
      <a className="link" target="_blank" href={value.includes('https://') || value.includes('http://') ? value : `https://${value}`}>
          {value}
      </a>
    );

    return (
        <td>
            {linkValue || <div className={className}>{value}</div>}
        </td>

    );
};

export default StaticPropertyCell;